import { Button, ImageWithRetry } from "@src/components/atoms";
import { useDCContext } from "@src/context/dcContext";

export const OnboardingWelcome = ({ onNext, previous }) => {
  const { getDynamicReplacement } = useDCContext();
  const signolLogo = getDynamicReplacement("logos__signol__blue");

  return (
    <div
      className={`h-full flex flex-col px-1 sm:px-6 animate-animated animate-fast ${previous < 1 ? "animate-zoomIn" : "animate-fadeInLeft"}`}
    >
      <div className="grow flex flex-col justify-center">
        <div className="font-bold text-primary-800 m-0 text-center">
          {getDynamicReplacement("onboarding__step1__title")}
        </div>
        <div className="flex justify-center py-1">
          <ImageWithRetry
            className="h-auto w-80"
            src={signolLogo}
            alt="Signol logo"
          />
        </div>
        <div className="font-bold text-primary-800 m-0 text-center">
          {getDynamicReplacement("onboarding__step1__title_account")}
        </div>
        <div className="flex justify-center pt-8 md:pt-12">
          <p className="text-base font-medium text-center">
            {getDynamicReplacement("onboarding__step1__content")}
          </p>
        </div>
        <div className="flex justify-center items-center p-2 md:p-3">
          <Button
            onClick={onNext}
            className="px-4 py-2 "
            children={getDynamicReplacement("onboarding__texts__get_started")}
          />
        </div>
      </div>
    </div>
  );
};
